import { Middleware } from 'redux';

import { AuthAction } from 'modules/auth/constants';
import { AuthActionType } from 'modules/auth/types';
import { Dispatch, RootState } from 'modules/redux';
import { modalHideAction } from 'modules/modals/actions';
import { RouterActionType } from 'modules/router/types';

const createModalsMiddleware: () => Middleware<RootState> =
  () =>
  ({ dispatch, getState }: { dispatch: Dispatch; getState: () => RootState }) =>
  next =>
  async (action: AuthActionType | RouterActionType) => {
    let nextAction;

    switch (action.type) {
      case AuthAction.LOGOUT: {
        const { modals }: RootState = getState();
        modals.forEach(
          modal => modal.open && dispatch(modalHideAction(modal.id)),
        );
        break;
      }
    }

    return nextAction ? nextAction : next(action);
  };

export default createModalsMiddleware;
